import { Star, Quote } from "lucide-react";
import { BuyButton } from "./BuyButton";

export const Testimonials = ({ content }) => {
  const items = content.testimonials || [];
  if (!items.length) return null;

  return (
    <section id="recensioni" className="bg-white py-16 sm:py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mb-12 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-terracotta">Cosa dicono le famiglie</span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl lg:text-4xl" data-testid="testimonials-title">
            Genitori e maestre lo adorano
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="relative flex flex-col rounded-2xl border border-sand bg-cream p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <Quote className="h-7 w-7 text-terracotta/40" />
              <span className="mt-3 flex gap-0.5" data-testid={`testimonial-stars-${i}`}>
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className={`h-4 w-4 ${s < t.stars ? "fill-amazon-orange text-amazon-orange" : "text-stone-300"}`} />
                ))}
              </span>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-stone-700 sm:text-base">“{t.text}”</blockquote>
              <figcaption className="mt-4 border-t border-sand pt-3">
                <span className="block font-display text-sm font-bold text-olive">{t.name}</span>
                <span className="block text-xs text-stone-500">{t.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <BuyButton url={content.amazon_url} price={content.price} testid="testimonials-buy-amazon-button" />
        </div>
      </div>
    </section>
  );
};
